import { PAGE_DATA_ID, dataPagePath } from "./dataPages.js";

const PAGE_DATA = new RegExp(`<script type="application/json" id="${PAGE_DATA_ID}">([\\s\\S]*?)</script>`);

const parsePageData = (json) => {
  try {
    return json ? JSON.parse(json) : {};
  } catch (error) {
    console.log(error);
    return {};
  }
};

// The data of the page the browser loaded first comes with the document.
const documentData = parsePageData(document.getElementById(PAGE_DATA_ID)?.textContent);

// Pages fetched lately for their data (page path -> promise of their data), most recent last.
const pages = new Map();
const MAX_PAGES = 8;

const fetchPage = (page) => {
  let pending = pages.get(page);
  if (pending) {
    pages.delete(page);
  } else {
    pending = fetch(page)
      .then((response) => (response.ok ? response.text() : response.status))
      .then((html) => (typeof html === "string" ? parsePageData(html.match(PAGE_DATA)?.[1]) : html))
      .catch((error) => {
        console.log(error);
        return null;
      });
    pending.then((data) => data === null && pages.delete(page));
  }
  pages.set(page, pending);
  while (pages.size > MAX_PAGES) {
    pages.delete(pages.keys().next().value);
  }
  return pending;
};

/**
 * A published data file (`path`: see ./paths.js) read from the prerendered page that carries it: its JSON,
 * 404 when no page carries it, null on failure. Same results as `fetchData` on the JSON files.
 */
export const fetchPageData = async (path) => {
  if (path in documentData) {
    return documentData[path];
  }
  const page = dataPagePath(path);
  if (!page) {
    return 404;
  }
  const data = await fetchPage(page);
  if (data === null) {
    return null;
  }
  return typeof data === "object" && path in data ? data[path] : 404;
};
